import { render, staticRenderFns } from "./ImportSuppliers.vue?vue&type=template&id=51157cd7&scoped=true"
import script from "./ImportSuppliers.vue?vue&type=script&lang=js"
export * from "./ImportSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51157cd7",
  null
  
)

export default component.exports